import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-persistency-dwreport",
  templateUrl: "./persistency-dwreport.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersistencyDWReportComponent {

  filters: string[];
  dashboardType = LookerRiskDashboardType.PERSISTENCY_REPORT_DW;
  hideFilters: string[] = [];

  constructor() {
    this.filters = ["Projects"];
    this.hideFilters = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID];
  }

}
